import React, { useState, useEffect } from "react";
import "./kitModal.css";
import plusIcon from "../../../../assets/plus.png";
import "reactjs-popup/dist/index.css";
import { useSelector } from "react-redux";
import { setCustomConfigData } from "../../../../redux/actions/custom-config-data-action";
import { useDispatch } from "react-redux";
import { setCustomCompId } from "../../../../redux/actions/custom-comp-id-action";
import { BaseUrl } from "../../../../config.js";
import crossicon from "../../../../assets/rr310/red-x.png";
import ComponentLoader from "../../../../components/componentLoader";
import axios from "axios";
import { ConfigBaseUrl } from "../../../../config.js";
import styleIcon from "../../../../assets/u400c/style.png";
import utilityIcon from "../../../../assets/u400c/utility.png";
import safetyIcon from "../../../../assets/u400c/safety.png";
import touringIcon from "../../../../assets/u400c/touring.png";
import styleComboIcon from "../../../../assets/u400c/styling_pack.png";
import utilityComboIcon from "../../../../assets/u400c/utility_pack.png";
import safetyComboIcon from "../../../../assets/u400c/safety_pack.png";
import touringComboIcon from "../../../../assets/u400c/touring_pack.png";

function KitModal({
  onKitModal,
  setAddKit,
  enableReset,
  warningMessage,
  cartWarningModal,
}) {
  const [loader, setLoader] = useState(false);
  const dispatch = useDispatch();
  const customConfigData = useSelector((state) => state.customConfigData.data);
  const meshdata = useSelector((state) => state.meshData.data);

  useEffect(() => {
    try {
      if (!customConfigData?.accessoriesData) {
        setLoader(true);
        axios({
          method: "post",
          url: ConfigBaseUrl() + "accessoriesUat",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          data: {
            categoryType: ["accessories"],
            categoryCode: [],
            genderfacet: [],
            segment: [],
            colorfacet: "",
            vehicleCode: "U400",
            pageNumber: 0,
            pageSize: 100,
          },
        }).then((res) => {
          const data = res.data;
          if (data?.status === "success") {
            const accessoriesArrData = data?.data?.filter(
              (el) =>
                el.Catogery === "Accessories" || el.Catogery === "Combo Pack"
            );

            let ans = accessoriesArrData?.reduce((agg, curr) => {
              let found = agg.find(
                (x) => x.ProductCatogery === curr.ProductCatogery
              );
              if (found) {
                found.data.push(curr);
              } else {
                agg.push({
                  ProductCatogery: curr.ProductCatogery,
                  Catogery: curr.Catogery,
                  data: [curr],
                });
              }
              return agg;
            }, []);

            const modifiedData = ans?.map((el) => {
              el.ProductCatogery === "Style" && (el.image = styleIcon);
              el.ProductCatogery === "Utility" && (el.image = utilityIcon);
              el.ProductCatogery === "Safety" && (el.image = safetyIcon);
              el.ProductCatogery === "Touring" && (el.image = touringIcon);
              el.ProductCatogery === "SAFETY Combo Pack" &&
                (el.image = safetyComboIcon);
              el.ProductCatogery === "STYLING Combo Pack" &&
                (el.image = styleComboIcon);
              el.ProductCatogery === "TOURING Combo Pack" &&
                (el.image = touringComboIcon);
              el.ProductCatogery === "UTILITY Combo Pack" &&
                (el.image = utilityComboIcon);
              return el;
            });

            const accessories = modifiedData.filter(
              (el) => el.Catogery == "Accessories"
            );

            customConfigData["accessoriesData"] = accessories;

            const combopack = modifiedData.filter(
              (el) => el.Catogery == "Combo Pack"
            );

            customConfigData["comboPack"] = combopack;

            dispatch(setCustomConfigData(structuredClone(customConfigData)));
            setLoader(false);
          } else {
            setLoader(false);
          }
        });
      }
    } catch (error) {
      setLoader(false);
    } finally {
    }
  }, []);

  var removeByAttr = function (arr, attr, value) {
    var i = arr.length;
    while (i--) {
      if (
        arr[i] &&
        arr[i].hasOwnProperty(attr) &&
        arguments.length > 2 &&
        arr[i][attr] === value
      ) {
        arr.splice(i, 1);
      }
    }
  };

  const onDeleteAccessories = (partNumber) => {
    const hasProductId = customConfigData?.orderDetails?.some(
      (item) => item.ProductId === partNumber
    );

    const merchandiseCartStatus = customConfigData?.merchandise?.some(
      (element) => {
        return element["cartStatus"] === true;
      }
    );

    const combopackCartStatus = customConfigData?.comboPack?.some((element) => {
      return element?.data?.some((elem) => {
        return elem["cartStatus"] === true;
      });
    });

    const accessoriesCartStatus = customConfigData?.accessoriesData?.some(
      (element) => {
        return element?.data?.some((elem) => {
          return elem["cartStatus"] === true;
        });
      }
    );

    const kitStatus = customConfigData?.kits?.some((item) => {
      return item["status"] === true;
    });
    if (hasProductId) {
      customConfigData.orderDetails.splice(
        customConfigData.orderDetails.findIndex(
          (item) => item.ProductId === partNumber
        ),
        1
      );
    }
    if (
      merchandiseCartStatus ||
      combopackCartStatus ||
      accessoriesCartStatus ||
      kitStatus
    ) {
      setAddKit(true);
    } else {
      setAddKit(false);
    }
  };

  /*********************************** Add Cart Warning Modal Start *************************************/

  ////////////acc-kit//////////////////
  const onAddCartWarning = (indexValue) => {
    let selectedNames = [];
    const DispatchArr = [];
    customConfigData?.businessRules?.forEach((el) => {
      if (
        el.type === "BlockDependence" &&
        el.dependent.partNumber === indexValue
      ) {
        customConfigData?.accessoriesData?.map((element) => {
          element?.data.map((e) => {
            if (
              e.ProductCode === el.selected.partNumber &&
              e.cartStatus === true
            ) {
              selectedNames.push(e.Name);

              warningMessage(
                `Adding ${
                  el.dependent.name
                } to your cart will replace the ${selectedNames
                  ?.toString()
                  .replace(/,/g, ", ")} selected, as it is included in the ${
                  el.dependent.name
                }.`
              );
              cartWarningModal(true);
              //

              customConfigData?.accessoriesData?.map((element) => {
                element?.data?.map((r) => {
                  if (r.ProductCode === e.ProductCode) {
                    r.cartStatus = false;
                  }
                });
              });
              onDeleteAccessories(e.ProductCode.toLowerCase());

              const hasId = [...DispatchArr]?.some(
                (item) => item.id === e.ProductCode
              );
              if (!hasId) {
                DispatchArr.push({
                  id: e.ProductCode,
                  status: false,
                });
              }
              //
            }
            // // addCartWarning(selectedNames, el.dependent.name);
            // addCartWarning(` Please remove ${selectedNames
            //   ?.toString()
            //   .replace(/,/g, ", ")} to add
            //  ${el.dependent.name}`);
          });
          ////////////////////////////////
        });
      }
      ////////////combo-kit///////////////
      if (
        el.type === "BlockDependence" &&
        el.dependent.partNumber === indexValue
      ) {
        customConfigData?.comboPack?.map((element) => {
          element?.data.map((e) => {
            if (
              e.ProductCode === el.selected.partNumber &&
              e.cartStatus === true
            ) {
              selectedNames.push(e.Name);

              // addCartWarning(selectedNames, el.dependent.name);
              warningMessage(
                `Adding ${
                  el.dependent.name
                } to your cart will replace the ${selectedNames
                  ?.toString()
                  .replace(/,/g, ", ")} selected, as it is included in the ${
                  el.dependent.name
                }.`
              );
              cartWarningModal(true);
              //

              customConfigData?.comboPack?.map((element) => {
                element?.data?.map((r) => {
                  if (r.ProductCode === e.ProductCode) {
                    r.cartStatus = false;
                  }
                });
              });

              // -- bug fixes --- //
              customConfigData?.businessRules?.forEach((elem) => {
                if (
                  elem.type === "BlockDependence" &&
                  elem.selected.partNumber === e.ProductCode
                ) {
                  customConfigData?.accessoriesData?.map((element) => {
                    element?.data?.map((eleme) => {
                      if (
                        eleme.ProductCode === elem.dependent.partNumber &&
                        eleme.disable === true
                      ) {
                        eleme.disable = false;
                      }
                    });
                  });
                }
              });
              ////

              onDeleteAccessories(e.ProductCode.toLowerCase());

              const hasId = [...DispatchArr]?.some(
                (item) => item.id === e.ProductCode
              );
              if (!hasId) {
                DispatchArr.push({
                  id: e.ProductCode,
                  status: false,
                });
              }
              //
            }
          });
        });
      }
      ///////////////////////////////////
    });
  };

  /*********************************** Add Cart Warning Modal End *************************************/
  const onSelect = (indexValue, name, price, deselect) => {
    onKitModal(false);

    enableReset(deselect && true);
    customConfigData?.kits?.map(
      (element) => indexValue === element.id && (element.status = !deselect)
    );

    // block-dependency disable acc and combo

    /* ******************   start   **************** */

    customConfigData?.businessRules?.map((el) => {
      if (
        el.type === "BlockDependence" &&
        el.selected.partNumber === indexValue
      ) {
        customConfigData?.kits?.map((r) => {
          if (r.id === el.selected.partNumber) {
            r.disable = false;
            customConfigData?.accessoriesData?.map((x) => {
              x?.data?.map((y) => {
                if (y.ProductCode === el.dependent.partNumber) {
                  y.disable = !deselect;
                }
              });
            });
            customConfigData?.comboPack?.map((x) => {
              x?.data?.map((y) => {
                if (y.ProductCode === el.dependent.partNumber) {
                  y.disable = !deselect;
                }
              });
            });
          }
        });
      }
    });

    /* ******************   end   **************** */

    //////////// Color //////////////
    const colorArray = customConfigData?.kits?.some((item) => {
      return item["status"] === true;
    });

    const countOfTrueStatus = customConfigData?.kits?.filter(
      (item) => item.status === true
    ).length;

    dispatch(
      setCustomCompId({
        id: indexValue,
        status: !deselect,
        kitResetStatus:
          (countOfTrueStatus === 1 && !deselect === true) ||
          (countOfTrueStatus === 0 && !deselect === false)
            ? true
            : false,
      })
    );

    if (countOfTrueStatus === 0) {
      meshdata[0]?.color.map((element, index) =>
        index === 0 ? (element.status = true) : (element.status = false)
      );
    }

    if (colorArray) {
      setAddKit(true);

      let defaultIndex = 0;
      customConfigData?.kits?.filter((item) => {
        if (item.status === true) {
          customConfigData?.color?.map((i) =>
            i?.groupIdAny.some((id) => {
              let kitId = item.id;
              if (id.toLowerCase() == kitId.toLowerCase()) {
                i.kit = true;
                i.defaultIndex = ++defaultIndex;
              }
            })
          );
          defaultIndex = 0;
        }
      });
    } else {
      setAddKit(false);
      customConfigData?.color?.map((i) => (i.kit = false));
    }

    if (countOfTrueStatus === 1 && !deselect === true) {
      customConfigData?.color?.map((element) =>
        element.defaultIndex === 1
          ? (element.status = true)
          : (element.status = false)
      );
    }

    //////////

    const colorData = customConfigData?.orderDetails?.some((item) => {
      return item["uId"] === "c01";
    });

    if (
      (countOfTrueStatus === 1 && !deselect === true) ||
      (countOfTrueStatus === 0 && !deselect === false)
    ) {
      customConfigData?.color?.map((element) => {
        if (element.defaultIndex === 1) {
          if (colorData) {
            customConfigData?.orderDetails?.filter((item) => {
              if (item.uId === "c01") {
                item.ProductId = element.id.toLowerCase();
                item.ProductName = "Color : " + element.name;
                item.Price = parseInt(element.price);
                item.Colour = element.id.toLowerCase();
              }
            });
          } else {
            customConfigData?.orderDetails.push({
              uId: "c01",
              isColor: true,
              ProductName: "Color : " + element.name,
              ProductId: "",
              Quantity: 1,
              Colour: element.id.toLowerCase(),
              Price: parseInt(element.price),
              Type: "BTO",
            });
          }
        }
      });
    }

    ////////

    //////////// Alloy Wheel //////////////
    let alloyIndex = 0;
    customConfigData?.color?.filter((item) => {
      if (item.status === true) {
        customConfigData?.alloyWheel?.map((i) =>
          i?.groupIdAny.some((id) => {
            let cId = item.id;

            if (id.toLowerCase() == cId.toLowerCase()) {
              alloyIndex = alloyIndex + 1;
              i.color = true;
              i.alloyIndex = alloyIndex;
            }
          })
        );
      }
    });
    customConfigData?.alloyWheel?.map((element) =>
      element.alloyIndex === 1
        ? (element.status = true)
        : (element.status = false)
    );

    //////////////  Order details  //////////////
    const array = customConfigData?.orderDetails?.some((item) => {
      return item["ProductId"] === indexValue.toLowerCase();
    });
    if (deselect) {
      removeByAttr(
        customConfigData?.orderDetails,
        "ProductId",
        indexValue.toLowerCase()
      );

      // customConfigData?.orderDetails?.filter((item) => {
      //   const kitValue = customConfigData.kits.some((e) => e.status === true);
      //
      //   if (item?.isColor && !kitValue) {
      //     removeByAttr(
      //       customConfigData?.orderDetails,
      //       "ProductId",
      //       item?.ProductId.toLowerCase()
      //     );
      //   }
      // });

      const colorArray = customConfigData?.orderDetails?.some((item) => {
        return item["uId"] === "c01";
      });

      if (
        (countOfTrueStatus === 1 && !deselect === true) ||
        (countOfTrueStatus === 0 && !deselect === false)
      ) {
        if (colorArray) {
          customConfigData?.orderDetails?.filter((item) => {
            if (item.uId === "c01") {
              item.ProductId = "";
              item.ProductName = "Color : " + meshdata[0]?.color[0]?.name;
              item.Price = meshdata[0]?.color[0]?.price;
              item.Colour = meshdata[0]?.color[0]?.id?.toLowerCase();
            }
          });
        } else {
          customConfigData?.orderDetails.push({
            uId: "c01",
            isColor: true,
            ProductName: "Color : " + meshdata[0]?.color[0]?.name,
            ProductId: "",
            Quantity: 1,
            Colour: meshdata[0]?.color[0]?.id?.toLowerCase(),
            Price: meshdata[0]?.color[0]?.price,
            Type: "BTO",
          });
        }
      }
    } else {
      if (array) {
        customConfigData?.orderDetails?.filter((item) => {
          if (item.ProductId === indexValue.toLowerCase()) {
            item.ProductId = indexValue.toLowerCase();
            item.ProductName = name;
            item.Price = parseInt(price);
          }
        });
      } else {
        customConfigData?.orderDetails.push({
          ProductName: name,
          ProductId: indexValue.toLowerCase(),
          Quantity: 1,
          Colour: "",
          Price: parseInt(price),
          Type: "BTO",
        });
      }
    }

    dispatch(setCustomConfigData(structuredClone(customConfigData)));
  };

  return (
    <>
      {loader ? (
        <ComponentLoader color={"#FFE100"} />
      ) : (
        <>
          {customConfigData?.kits ? (
            <div
              style={{
                backgroundColor: "#FFFF",
                border: "1px solid #B6B6B6",
                zIndex: "1",
                width: "auto",
                borderRadius: "0.75rem",
                display: " flex",
                flexDirection: "row",
                position: "relative",
              }}
            >
              {customConfigData?.kits?.map((item, key) => (
                <>
                  <div className="line"></div>
                  <div className="kit-container" key={key}>
                    <div className="kit-header mediumFont">{item.name}</div>
                    <img
                      alt="kit"
                      className="kit-image"
                      src={BaseUrl() + item?.description?.path}
                    ></img>
                    <div className="kit-desc mediumFont">
                      {item?.description?.meta}
                    </div>
                    <button
                      className="select-button mediumFont"
                      id={item.status ? "Remove" : "Select"}
                      kit-value={item.id}
                      style={{
                        opacity: item?.disable && 0.5,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (!item.disable) {
                          onSelect(item.id, item.name, item.price, item.status);
                        } else {
                          onAddCartWarning(item.id);
                          onSelect(item.id, item.name, item.price, item.status);
                        }
                      }}
                    >
                      {item.status ? "Remove" : "Select"}
                      {!item.status && <img src={plusIcon} alt="plus" />}
                    </button>
                  </div>
                </>
              ))}
              <div className="CloseBtn">
                <button
                  onClick={() => {
                    onKitModal(false);
                  }}
                >
                  <img
                    src={crossicon}
                    style={{ width: "1.7rem" }}
                    alt="cancel"
                  />
                </button>
              </div>
            </div>
          ) : (
            <ComponentLoader color={"#FFE100"} />
          )}
        </>
      )}
    </>
  );
}

export default KitModal;
